import React, { useState, useCallback, useEffect } from "react";
import { Select, Spin } from "antd";
import axios from "axios";
import { debounce } from "@mui/material";
import { CONFIG } from "../../config";
import api from "../../utils/axios";
import googleLogo from "../../assets/google_on_white_hdpi.png";
import { toast } from "react-toastify";

type Address = {
	id: number;
	address: string;
	sectionId?: number;
	latitude?: string;
	longitude?: string;
	placeId?: string;
};

type Props = {
	onAddressChange: (address: {
		lat: string;
		lng: string;
		label: string;
	}) => void;
	country: string;
	selectedAddress: any;
	city: string | number | undefined;
	disabled?: boolean;
	placeholder?: string;
	style?: React.CSSProperties;
};

const { Option } = Select;

const AddressSelect: React.FC<Props> = ({
	onAddressChange,
	country,
	selectedAddress,
	city,
	disabled,
	placeholder,
	style,
}) => {
	const [results, setResults] = useState<Address[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setResults([]);
	}, [country, city]);

	const searchAddresses = useCallback(
		debounce(async (searchTerm: string) => {
			if (!searchTerm.trim()) {
				setResults([]);
				return;
			}

			setLoading(true);
			try {
				const { data: localResults } = await api.get<Address[]>(
					`Configuration?address=${searchTerm}&country=${country}&cityId=${city}`
				);

				if (localResults && localResults.length > 0) {
					setResults(localResults);
				}
			} catch (error) {
				console.error("Error fetching addresses:", error);
			} finally {
				setLoading(false);
			}
		}, 300),
		[country, city]
	);

	const handleSearch = (value: string) => {
		if (!country || !city) {
			toast.error(
				"Ju lutem selektoni Shtetin dhe Qytetin per te vazhduar me adresen!"
			);
			return;
		}
		searchAddresses(value);
	};

	const handleSelect = async (selectedId: number) => {
		const selectedAddress = results.find((item) => item.id === selectedId);
		if (selectedAddress) {
			if (selectedAddress.placeId) {
				const latLng = await selectLngLatFromPlaceId(
					selectedAddress.placeId
				);
				console.log(latLng);
				if (latLng) {
					onAddressChange({
						lat: latLng.latitude || "",
						lng: latLng.longitude || "",
						label: selectedAddress.address,
					});
				}
			} else {
				onAddressChange({
					lat: selectedAddress.latitude || "",
					lng: selectedAddress.longitude || "",
					label: selectedAddress.address,
				});
			}
		}
	};

	const selectLngLatFromPlaceId = async (placeId: string) => {
		try {
			const result = await api.get(
				`Configuration/select-address-details?placeId=${placeId}`
			);
			const response = result.data;
			if (result.status === 200) {
				return response;
			}
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<Select
			showSearch
			placeholder={placeholder ?? "Search address"}
			notFoundContent={loading ? <Spin size="small" /> : null}
			filterOption={false}
			onSearch={handleSearch}
			onSelect={handleSelect}
			value={selectedAddress}
			disabled={disabled}
			style={style}
			// style={{ width: "100%" }}
			className="registerInput"
			dropdownRender={(menu) => (
				<>
					{menu}
					<div
						style={{
							textAlign: "right",
							padding: "4px 8px",
							justifyContent: "flex-end",
						}}
					>
						<img
							src={googleLogo}
							alt="Powered by Google"
							style={{ height: 14 }}
						/>
					</div>
				</>
			)}
		>
			{results.map((item) => (
				<Option key={item.id} value={item.id}>
					{item.address}
				</Option>
			))}
		</Select>
	);
};

export default AddressSelect;
